var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"outer",style:(_vm.card_style),attrs:{"id":"outer"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('CardRenderer',{style:(_vm.card_translate),attrs:{"id":"card","type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }